export type FailedCheckColor = "red" | "yellow" | "green" | "default";

export const FAILED_CHECK_COLOR_OPTIONS: { value: FailedCheckColor; label: string }[] = [
  { value: "red", label: "Красный" },
  { value: "yellow", label: "Жёлтый" },
  { value: "green", label: "Зелёный" },
  { value: "default", label: "Нет" },
];

export const normalizeFailedCheckColor = (value?: string | null): FailedCheckColor => {
  const normalized = value?.trim().toLowerCase();
  if (normalized === "red" || normalized === "yellow" || normalized === "green" || normalized === "default") {
    return normalized;
  }
  return "default";
};

export const getFailedCheckColorLabel = (value?: string | null): string => {
  const normalized = normalizeFailedCheckColor(value);
  return FAILED_CHECK_COLOR_OPTIONS.find((option) => option.value === normalized)?.label ?? "—";
};

export const getCheckActiveLabel = (active?: boolean): string =>
  active === false ? "Неактивна" : "Активна";
